import { render, staticRenderFns } from "./ComparisonShow.vue?vue&type=template&id=53736aec&"
import script from "./ComparisonShow.vue?vue&type=script&lang=js&"
export * from "./ComparisonShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports